import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { assetUrl } from "../../lib/api";

export const LandingBuilders = ({ builders }) => {
  if (!builders?.length) return null;
  return (
    <section className="mt-20" data-testid="landing-builders">
      <p className="eyebrow text-[#C9B79C] mb-3">Approved builders</p>
      <h2 className="font-display font-light text-3xl md:text-4xl text-[#F3EEE3] mb-8">
        Custom home builders in Spruce Grove &amp; the Edmonton area
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {builders.map((b) => (
          <Link
            key={b.id}
            to={`/builders/${b.id}`}
            data-testid={`landing-builder-${b.id}`}
            className="group rounded-2xl border border-[#F3EEE3]/12 bg-[#0F1B15] p-4 flex items-center gap-3 hover:border-[#C9B79C]/50 transition-colors"
          >
            {b.logo_url ? (
              <img src={assetUrl(b.logo_url)} alt={`${b.name} logo`} loading="lazy" className="w-12 h-12 rounded-lg object-cover shrink-0 border border-[#F3EEE3]/10" />
            ) : (
              <span className="w-12 h-12 rounded-lg bg-[#C9B79C]/15 flex items-center justify-center font-display text-[#C9B79C] shrink-0">{b.name[0]}</span>
            )}
            <span className="text-[#F3EEE3]/85 text-sm leading-snug group-hover:text-[#F3EEE3]">{b.name}</span>
          </Link>
        ))}
      </div>
      <Link to="/builders" className="inline-flex items-center gap-2 text-[#C9B79C] hover:text-[#F3EEE3] text-sm mt-6" data-testid="landing-all-builders">
        All builders <ArrowRight size={14} />
      </Link>
    </section>
  );
};

export const LandingStages = ({ stages }) => {
  const list = (stages || []).filter((s) => s.number >= 7 && s.number <= 9);
  if (!list.length) return null;
  return (
    <section className="mt-20" data-testid="landing-stages">
      <p className="eyebrow text-[#C9B79C] mb-3">Where homes are rising</p>
      <h2 className="font-display font-light text-3xl md:text-4xl text-[#F3EEE3] mb-8">Current stages</h2>
      <div className="grid sm:grid-cols-3 gap-3">
        {list.map((s) => (
          <Link
            key={s.id}
            to={`/stages/${s.id}`}
            data-testid={`landing-stage-${s.number}`}
            className="rounded-2xl border border-[#F3EEE3]/12 bg-[#0F1B15] p-6 hover:border-[#C9B79C]/50 transition-colors"
          >
            <span className={`text-[0.6rem] tracking-wide uppercase px-2.5 py-1 rounded-full ${s.status === "available" ? "bg-[#C9B79C] text-[#12201A]" : "bg-[#1B2E24] text-[#F3EEE3]/70"}`}>
              {s.status_label}
            </span>
            <p className="font-display text-2xl text-[#F3EEE3] mt-4">{s.name}</p>
            <p className="text-[#F3EEE3]/60 text-sm mt-2 leading-relaxed line-clamp-3">{s.description}</p>
          </Link>
        ))}
      </div>
    </section>
  );
};
